// Small fetch wrapper for the Cloudflare Worker API that replaces Firestore.
// Admin key is read from REACT_APP_ADMIN_API_KEY (never hardcode it here).

const API_BASE_URL = "https://templates-api.anshukumarbtc.workers.dev";

const ADMIN_API_KEY = process.env.REACT_APP_ADMIN_API_KEY;

if (!ADMIN_API_KEY) {
  console.error(
    "[api] REACT_APP_ADMIN_API_KEY is not set. " +
      "Admin operations (create/update/delete) will fail. " +
      "Add it to your .env file locally and to Vercel env vars for production."
  );
}

const request = async (method, path, body) => {
  const headers = { "Content-Type": "application/json" };
  if (ADMIN_API_KEY) headers["X-API-Key"] = ADMIN_API_KEY;

  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(
      `API ${method} ${path} failed (${response.status}): ${text}`
    );
  }
  return response.json();
};

export const apiGet = (path) => request("GET", path);
export const apiPost = (path, body) => request("POST", path, body);
export const apiPut = (path, body) => request("PUT", path, body);
export const apiDelete = (path) => request("DELETE", path);
